/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VorlagenwechselAuftrag
 */
export interface VorlagenwechselAuftrag {
    /**
     * 
     * @type {string}
     * @memberof VorlagenwechselAuftrag
     */
    zielVorlageId: string;
    /**
     * Name der neuen Datenbank; leer = Quellname plus Vorlagenname
     * @type {string}
     * @memberof VorlagenwechselAuftrag
     */
    neuerName?: string;
    /**
     * Quell-Feld-IDs, die NICHT uebertragen werden
     * @type {Array<string>}
     * @memberof VorlagenwechselAuftrag
     */
    abgewaehlteFelder?: Array<string>;
}

/**
 * Check if a given object implements the VorlagenwechselAuftrag interface.
 */
export function instanceOfVorlagenwechselAuftrag(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "zielVorlageId" in value;

    return isInstance;
}

export function VorlagenwechselAuftragFromJSON(json: any): VorlagenwechselAuftrag {
    return VorlagenwechselAuftragFromJSONTyped(json, false);
}

export function VorlagenwechselAuftragFromJSONTyped(json: any, ignoreDiscriminator: boolean): VorlagenwechselAuftrag {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'zielVorlageId': json['zielVorlageId'],
        'neuerName': !exists(json, 'neuerName') ? undefined : json['neuerName'],
        'abgewaehlteFelder': !exists(json, 'abgewaehlteFelder') ? undefined : json['abgewaehlteFelder'],
    };
}

export function VorlagenwechselAuftragToJSON(value?: VorlagenwechselAuftrag | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'zielVorlageId': value.zielVorlageId,
        'neuerName': value.neuerName,
        'abgewaehlteFelder': value.abgewaehlteFelder,
    };
}

